
import { RequestBase, RequestBasePageIds, RequestBaseSet, RequestDeleteIds, ResponseBasePage, ResponseBaseSet } from "src/app/modules/fwcore/models";
import { DealGroup } from "src/app/features/prob/models";


export class RequestDealGroup extends RequestBasePageIds {

  /**
 * The list of deal group codes to filter the request.
 */
  codes?: string[] | null;

  /**
   * Indicates whether only active deal groups should be included.
   */
  isActive?: boolean | null;

}

export class ResponseDealGroup extends ResponseBasePage<DealGroup> {
}

export class RequestDealGroupSet extends RequestBaseSet<DealGroup> {
}

export class ResponseDealGroupSet extends ResponseBaseSet<DealGroup> {
}

export class RequestDealGroupDelete extends RequestDeleteIds {

  hardDelete?: boolean | null;
}

/**
 * Represents a request to refresh the question and deal caches for specified deal group or deal type.
 * @remarks Use this class to initiate a cache refresh operation for questions or deals associated with a
 * particular deal group or deal type. Mutually exclusive.
 */
export class RequestQuCacheRefresh extends RequestBase {


  /** Refresh the question cache for the deal group */
  dealGroupId?: string | null = null;

  /** Refresh the deal cache for the deal type */
  dealTypeId?: string | null = null;

}


